/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
//icon
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/searchbar/searchbar_styles';



/* ========== ~~~~~~~~~~ FORM : FIELD  : TEXT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const SearchBar = (props) => {
    return (
        <div className={`searchbar ${props.classes.searchbar}`}>
           <Icon name={`search`} />
            <span className={`element`}>
                 <input type={props.type} name={props.name} placeholder={props.placeholder} onFocus={props.handleFocus} onBlur={props.handleBlur} onChange={e=>props.onChange(e.target.value)} value={props.value} />
            </span>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SearchBar);